import Box from '@mui/material/Box'
import { borderRadius, colors, shadows, spacing, transitions } from '@shared'
import type { PropsWithChildren } from 'react'

export const LoginCard = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 400,
        background: colors.background.secondary,
        borderRadius: borderRadius.xl,
        padding: spacing[8],
        boxShadow: shadows.base,
        backdropFilter: 'blur(20px)',
        border: `1px solid ${colors.border.light}`,
        transition: transitions.base
      }}
    >
      {children}
    </Box>
  )
}
